var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { PersistedObservable, persistedObservable } from '../../observable/persistedObservable';
import { LoadPriority } from '../../store/store';
import { UserMetadata } from './models/userMetadata';
import { UserInbox } from './models/userInbox';
import { UserMemberships } from './models/userMemberships';
import { UserSettings } from './models/userSettings';
let User = class User extends PersistedObservable {
    memberships;
    inbox;
    deviceKeys;
    settings;
    constructor(id, store, riverConnection) {
        super({ id }, store, LoadPriority.high);
        this.memberships = new UserMemberships(id, store, riverConnection);
        this.inbox = new UserInbox(id, store, riverConnection);
        this.deviceKeys = new UserMetadata(id, store, riverConnection);
        this.settings = new UserSettings(id, store, riverConnection);
    }
};
User = __decorate([
    persistedObservable({ tableName: 'user' })
], User);
export { User };
//# sourceMappingURL=user.js.map